/* HotDawgs — product page ember glow
   Same ember effect as the hero, contained to the gallery card instead of
   the full viewport. Ambient only — no solid geometry (see hero-scene.js
   changelog: shapes read as clutter, particles read as atmosphere). */

(function () {
  const canvas = document.getElementById('pd-ember-canvas');
  const wrap = document.querySelector('.pd-gallery-wrap');
  if (!canvas || !wrap || typeof THREE === 'undefined') return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(45, 1, 0.1, 50);
  camera.position.set(0, 0, 9);

  const renderer = new THREE.WebGLRenderer({ canvas, antialias: true, alpha: true });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

  function sizeToWrap() {
    const w = wrap.clientWidth;
    const h = wrap.clientHeight;
    renderer.setSize(w, h);
    camera.aspect = w / h;
    camera.updateProjectionMatrix();
  }
  sizeToWrap();
  window.addEventListener('resize', sizeToWrap);

  function makeEmberTexture() {
    const size = 64;
    const c = document.createElement('canvas');
    c.width = c.height = size;
    const ctx = c.getContext('2d');
    const g = ctx.createRadialGradient(size / 2, size / 2, 0, size / 2, size / 2, size / 2);
    g.addColorStop(0, 'rgba(255,225,190,1)');
    g.addColorStop(0.35, 'rgba(255,106,0,0.85)');
    g.addColorStop(1, 'rgba(255,106,0,0)');
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, size, size);
    return new THREE.CanvasTexture(c);
  }

  const COUNT = 60;
  const geo = new THREE.BufferGeometry();
  const positions = new Float32Array(COUNT * 3);
  const speeds = new Float32Array(COUNT);
  const drifts = new Float32Array(COUNT);

  for (let i = 0; i < COUNT; i++) {
    positions[i * 3] = (Math.random() - 0.5) * 9;
    positions[i * 3 + 1] = (Math.random() - 0.5) * 9;
    positions[i * 3 + 2] = (Math.random() - 0.5) * 4;
    speeds[i] = 0.008 + Math.random() * 0.018;
    drifts[i] = Math.random() * Math.PI * 2;
  }
  geo.setAttribute('position', new THREE.BufferAttribute(positions, 3));

  const mat = new THREE.PointsMaterial({
    size: 0.32,
    map: makeEmberTexture(),
    transparent: true,
    depthWrite: false,
    blending: THREE.AdditiveBlending,
    opacity: 0.8,
  });
  const embers = new THREE.Points(geo, mat);
  scene.add(embers);

  let t = 0;
  function animate() {
    requestAnimationFrame(animate);
    t += prefersReducedMotion ? 0.0015 : 0.006;

    if (!prefersReducedMotion) {
      const pos = geo.getAttribute('position');
      for (let i = 0; i < COUNT; i++) {
        let y = pos.getY(i) + speeds[i];
        let x = pos.getX(i) + Math.sin(t + drifts[i]) * 0.003;
        if (y > 4.6) y = -4.6;
        pos.setY(i, y);
        pos.setX(i, x);
      }
      pos.needsUpdate = true;
    }

    renderer.render(scene, camera);
  }
  animate();
})();
